import React from 'react';

import './ColorValue.scss';

export default ({ color }: { color?: string }) => {
	return (
		<div className="ColorValue" style={{ backgroundColor: color }} title={color}>
		</div>
	);
};